module.exports = __webpack_public_path__ + "static/img/iconfont.3e096ae1.svg";